import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';
import reducer from '../Search/reducer';
import saga from '../Search/saga';

import { makeSelectSelectedParams } from '../Search/selectors';
import { updateParam } from '../Search/actions';

import { Input, InputNumber } from 'antd';
import { InputSlider } from '../UIKit';

import { getObjByAttribute } from '../../utils/common';

import './styles.scss';

class Slider extends React.Component {
  constructor(props) {
    super(props);

    this.sliderRef = React.createRef();
  }

  get currentValues() {
    const { name, selectedParams, max } = this.props;

    const current = getObjByAttribute(selectedParams, 'name', name);

    let value = max;

    if (current && current.value) {
      value = current.value;
    }

    return value;
  }

  onChange = value =>
    this.props.updateValue({
      name: this.props.name,
      value,
      label: this.props.label,
    });

  render() {
    let {
      label,
      unit,
      items,
      withStepLabel,
      labelFormatter,
    } = this.props;

    const value = this.currentValues

    const formatValueLabel = value =>
      labelFormatter
        ? labelFormatter(value, unit)
        : `${value}${unit ? ` ${unit}` : ''}`;

    return (
      <div className="mb-5">
        <h4 className="todo-sidebar-section-header">
          {label}
        </h4>
        <InputSlider
          range={false}
          steps={items}
          value={value}
          onChange={this.onChange}
          labelFormatter={formatValueLabel}
          withStepLabel={withStepLabel}
          ref={this.sliderRef}
        />
      </div>
    );
  }
}

Slider.defaultProps = {
  withStepLabel: true,
};

Slider.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  items: PropTypes.array,
  unit: PropTypes.string,
  withStepLabel: PropTypes.bool,
  labelFormatter: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  selectedParams: makeSelectSelectedParams(),
});

export function mapDispatchToProps(dispatch) {
  return {
    updateValue: values => dispatch(updateParam(values)),
  };
}

const withReducer = injectReducer({ key: 'search', reducer });
const withSaga = injectSaga({ key: 'search', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(Slider);
